import { useNotepadStore } from "../store/useNotepadStore";
import { useSessionStore } from "@/features/tutor/store/useSessionStore";
import { useSlideStore } from "@/features/tutor/store/useSlideStore";

export function restorePagesFromSession(): boolean {
  const notepadStore = useNotepadStore.getState();
  if (notepadStore.isLimitedMode) return false;
  if (notepadStore.pages.length > 0) return false;

  const sessionId = useSessionStore.getState().getSessionId?.();
  const slideIndex = useSlideStore.getState().currentSlideIndex;
  if (sessionId == null || slideIndex == null) return false;

  const slideKey = `${sessionId}-${slideIndex}`;
  try {
    const raw = sessionStorage.getItem(`canvas_pages_${slideKey}`);
    if (raw) {
      const indices = JSON.parse(raw);
      if (Array.isArray(indices) && indices.length > 0) {
        useNotepadStore.getState().restorePages(indices);
        return true;
      }
    }
  } catch { /* best-effort */ }
  return false;
}
